import React from "react";

export default function TabButton({active, onClick, children}: { active: boolean, onClick: () => void, children: React.ReactNode }) {
    return (
        <button onClick={onClick}
                className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${active ? "border-primary text-white" : "border-transparent text-neutral-400 hover:text-white"}`}>
            {children}
        </button>
    )
}
